// Configure AWS Amplify before any other imports
import './amplify-config';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installSignedOutGuard } from './auth/signOut';

installSignedOutGuard();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
